// import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import './router/http' // 引入axios
import './other/ivewImport' // ivew 模块引入
import './other/plugin' // 所有引入的第三方插件
import axios from 'axios'
import router from './router/router'
import dateTool from 'date-and-time'
axios.prototype.$https = axios
import './assets/scss/my-theme/my-theme.less'
import './assets/scss/index.scss'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import en from 'view-design/dist/locale/en-US'
import zh from 'view-design/dist/locale/zh-CN'
import echarts from 'echarts'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueCountdown from '@chenfengyuan/vue-countdown'
// import "@scss/element-variables.scss";

// import VConsole from 'vconsole';
// const vConsole = new VConsole();

Vue.use(Element)
Vue.component(VueCountdown.name, VueCountdown)

Vue.prototype.$echarts = echarts
Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.use(router)
Vue.use(VueCookies)

Vue.locale = () => {}

const messages = {
  en: Object.assign(en),
  zh: Object.assign(zh)
}

const i18n = new VueI18n({
  locale: 'zh', // set locale
  messages // set locale messages
})

//全局过滤器
Vue.filter('dateFormat', function(value) {
  return dateTool.format(new Date(value), 'YYYY-MM-DD HH:mm:ss')
})

Vue.filter('character', (val) => {
  return val.replaceAll(',', '/')
})

 function  handleSpinCustom() {
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18,
              },
            }),
            h("div", "加载中..."),
          ]);
        },
      });
      // setTimeout(() => {
      //     this.$Spin.hide();
      // }, 30000);
    }

    // 把 handleSpinCustom 方法挂载到 Vue 原型上
Vue.prototype.$handleSpinCustom = handleSpinCustom;

    //   this.$handleSpinCustom(); 
    //   this.$Spin.hide();






new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
